import { getServices } from '../../../infra/startup';
import AuthInterface from './AuthInterface';
import IAuthInterface from './IAuthInterface';

// Singleton instance to maintain backwards compatibility
let authServiceInstance: IAuthInterface;

export default function authProvider(): IAuthInterface {
  if (authServiceInstance) {
    return authServiceInstance;
  }

  const services = getServices();
  const {
    sessionService,
    loginService,
    authProviderService,
    tenantHandlerService
  } = services;

  authServiceInstance = new AuthInterface({
    sessionService,
    loginService,
    authProviderService,
    tenantHandlerService
  });

  return authServiceInstance;
}
